module.exports = __webpack_public_path__ + "img/gridGalleryAR.a8d5154a.svg";